import { render } from "./Pa-Header.vue?vue&type=template&id=4fff42dd"
import script from "./Pa-Header.vue?vue&type=script&lang=js"
export * from "./Pa-Header.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/prime-asia-lg-samsung/prime-asia-lg-samsung/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__